import * as React from "react";
function SvgCircles(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={7}
        cy={5}
        r={4}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle
        cx={25}
        cy={25}
        r={6}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle
        cx={4}
        cy={28}
        r={3}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M24.82 19A11.94 11.94 0 0011 5.18M6.92 27.33a11.93 11.93 0 0012.48-.19M4.75 8.3A12 12 0 004.08 25"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircles);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
